<template>
  <main>
    <md-steppers md-active-step="apply" md-alternative md-linear>
      <md-step id="email" md-label="メール認証"></md-step>
      <md-step id="apply" md-label="本契約の手続き"></md-step>
      <md-step id="start" md-label="ご利用開始"></md-step>
    </md-steppers>

    <div class="md-layout md-alignment-center">
      <md-card class="md-layout-item md-size-90 md-small-size-100">
        <!-- ローディング／エラーメッセージ -->
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
            </div>
          </div>
        </md-card-content>

        <div class="md-layout">
          <div class="md-layout-item md-size-5 md-small-size-100"></div>
          <div class="md-layout-item md-size-90 md-small-size-100">
            <md-card-header>
              <div class="md-title">ご登録内容の確認</div>
              <div class="md-title text-error">※まだ本契約は完了しておりません。</div>
            </md-card-header>

            <!-- 登記情報提供サービスIDを認証 -->
            <md-card-header>
              <div class="md-title">登記情報提供サービスのアカウントを認証</div>
            </md-card-header>
            <contract-preview-t-service
                :t_service_id="formData.contractTService.t_service_id"></contract-preview-t-service>

            <!-- 申込内容 -->
            <md-card-header>
              <div class="md-title">申込内容</div>
            </md-card-header>
            <contract-preview-apply :form="formData.contractApply"></contract-preview-apply>

            <!-- 決済方法 -->
            <md-card-header>
              <div class="md-title">決済方法</div>
            </md-card-header>
            <contract-preview-payment :form="formData.contractPayment"></contract-preview-payment>

            <!-- 請求書の送付方法 -->
            <md-card-header>
              <div class="md-title">請求書の送付方法</div>
            </md-card-header>
            <contract-preview-send :form="formData.contractSend"></contract-preview-send>

            <!-- その他 -->
            <contract-preview-etc :form="formData.contractEtc"></contract-preview-etc>

            <!-- 利用規約 -->
            <contract-preview-term :apply="formData.contractTerm.apply"></contract-preview-term>

            <md-card-actions>
              <div class="md-layout md-alignment-top-center">
                <md-button type="button" class="md-button md-raised" :disabled="sending" @click="back()">
                  <md-icon>arrow_left</md-icon>
                  <span>入力画面へ戻る</span>
                </md-button>
              </div>
              <div class="md-layout md-alignment-top-center">
                <md-button type="submit" class="md-button md-primary md-raised" :disabled="sending"
                           @click="showFeeExplanation = true">
                  <span>この内容で登録する</span>
                  <md-icon>arrow_right</md-icon>
                </md-button>
              </div>
            </md-card-actions>
          </div>
        </div>
      </md-card>

      <!--本契約についてダイアログ-->
      <md-dialog :md-active.sync="showFeeExplanation">
        <md-dialog-title>本契約について</md-dialog-title>
        <md-dialog-content>
          登録すると月額料金が発生します。<br/>
          ￥12,000/月（1ID）（請求書郵送をご希望の場合：別途￥300/月）※税抜<br/>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button class="md-primary md-raised" @click="register()">
            <span>登録する</span>
            <md-icon>arrow_right</md-icon>
          </md-button>
        </md-dialog-actions>
        <loading-spinner-overlay v-if="sending" :background="'#CCCCCC'"></loading-spinner-overlay>
      </md-dialog>
    </div>
  </main>
</template>　

<script>
import CommonMixin              from '../../mixins/commonMixin';
import FlashMessage             from '../../components/FlashMessage';
import LoadingSpinner           from '../../components/LoadingSpinner';
import LoadingSpinnerOverlay    from '../../components/LoadingSpinnerOverlay';
import ActivationModal          from '../../components/ActivationModal';
import ContractPreviewTService  from "../../components/contract/ContractPreviewTService";
import ContractPreviewApply     from "../../components/contract/ContractPreviewApply";
import ContractPreviewPayment   from "../../components/contract/ContractPreviewPayment";
import ContractPreviewSend      from "../../components/contract/ContractPreviewSend";
import ContractPreviewEtc       from "../../components/contract/ContractPreviewEtc";
import ContractPreviewTerm      from "../../components/contract/ContractPreviewTerm";
import {validationMixin}        from 'vuelidate'
import {mapActions, mapGetters} from "vuex";
import {apiClient, apiList}     from "../../modules/apiClient";
import Common                   from "../../modules/common";

export default {
  name      : "ContractPreview",
  components: {
    LoadingSpinnerOverlay,
    LoadingSpinner,
    FlashMessage,
    ActivationModal,
    ContractPreviewTService,
    ContractPreviewApply,
    ContractPreviewPayment,
    ContractPreviewSend,
    ContractPreviewEtc,
    ContractPreviewTerm
  },
  mixins    : [CommonMixin, validationMixin],
  data      : () => ({
    showFeeExplanation: false,
  }),
  mounted() {
    this.saveValidateResponse([]);
    this.saveErrorMessages([]);
    if (this.formData === null) {
      return this.back();
    }
    this.scrollToTop();
  },
  methods : {
    ...mapActions('contractForm', [
      'saveFormData',
    ]),
    ...mapActions('contractFormError', [
      'saveValidateResponse',
      'saveErrorMessages',
    ]),
    back() {
      localStorage.setItem(Common.localStorageKeys.contract.verify, 'ContractPreview');
      this.$router.back();
    },
    createFormData() {
      let form = {
        t_service_id: this.formData.contractTService.t_service_id,
        corporation : this.formData.contractApply.corporation,
        account     : this.formData.contractApply.account,
        bill_method : this.formData.contractPayment.bill_method,
        bill_via    : this.formData.contractSend.bill_via,
        name1       : this.formData.contractSend.name1,
        name2       : this.formData.contractSend.name2,
        name3       : this.formData.contractSend.name3,
        email       : this.formData.contractSend.email,
        etc         : this.formData.contractSend.etc,
        contract    : this.formData.contractEtc.contract,
        apply       : this.formData.contractTerm.apply,
      }
      if (this.formData.contractPayment.bill_method === Common.billingMethodCreditCard) {
        form = Object.assign(form, {
          card_token: this.formData.contractPayment.cardToken,
        })
      }
      if (this.formData.contractPayment.bill_via !== Common.billingViaEmail) {
        form = Object.assign(form, {
          postal       : this.formData.contractSend.postal,
          pref         : this.formData.contractSend.pref,
          city         : this.formData.contractSend.city,
          street_name  : this.formData.contractSend.street_name,
          street_number: this.formData.contractSend.street_number,
        })
      }
      this.formData.contractSend.additionalAddresses = this.formData.contractSend.additionalAddresses.filter(email => email);
      Object.assign(form, {
        additional_addresses: this.formData.contractSend.additionalAddresses.map(email => email)
      })
      return form;
    },
    register() {
      this.errorMessages = [];
      this.sending       = true;
      apiClient.post(apiList.application.contract, this.createFormData())
          .then(response => {
            if (this.hasResponseErrors(response)) {
              if (this.validateResponse.length) {
                this.saveValidateResponse(this.validateResponse)
              }
              if (this.errorMessages.length) {
                this.saveErrorMessages(this.errorMessages)
              }
              localStorage.setItem(Common.localStorageKeys.contract.verify, 'ContractPreview');
              this.$router.push({name: 'ContractApply'})
              return
            }

            // 本登録完了へ遷移したことをGTMのdataLayerに通知する
            dataLayer.push({
              event: 'ContractRegistrationComplete',
            });

            this.$router.push({name: 'ContractComplete'})
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending            = false;
            this.showFeeExplanation = false;
          });
    },
  },
  computed: {
    ...mapGetters('contractForm', {
      formData: 'formData',
    }),
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components";

.md-steppers {
  height: 104px;
}

.md-stepper {
  padding: 0;
}

.md-card {
  margin-top: 20px;
  margin-bottom: 30px;
}

.mg-l-20 {
  margin-left: 20px;
}

.md-checked {
  color: #ff5252 !important;
}

.check-same-corp {
  margin-top: 16px;
}

button.check-same-corp {
  margin-left: 0;
  margin-top: 0;
}

.text-error {
  color: #ff5252;
}

.md-attention {
  color: #ff5252;
}

.md-card-actions {
  .md-button {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 1024px) {
  .check-same-corp {
    i {
      display: none;
    }
  }
}
</style>
